import { render } from "./DatePickerInput.vue?vue&type=template&id=b0d87024"
import script from "./DatePickerInput.vue?vue&type=script&lang=ts"
export * from "./DatePickerInput.vue?vue&type=script&lang=ts"
script.render = render

export default script